// extracted by mini-css-extract-plugin
module.exports = {"numberInputContainer":"number-input_numberInputContainer__2gjEs","number":"number-input_number__Pxd_s","control":"number-input_control__VD7kU"};